<template>
  <div class="header">
    <el-menu :default-active="active" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item v-for="item in menuList" :key="item.index" :index="item.index">{{ item.name }}</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {},
  data() {
    return {
      active: '1',
      menuList: [
        {
          index: '1',
          name: 'JSON工具',
          path: '/'
        },
        {
          index: '2',
          name: '编码',
          path: '/encode'
        },
        {
          index: '3',
          name: '时间戳',
          path: '/time'
        },
        {
          index: '4',
          name: '手写板',
          path: '/sign'
        }
      ],
      currentPath: '/'
    }
  },
  created() {
    this.currentPath = this.$route.path
    this.changeMenuActive()
  },
  methods: {
    handleSelect(index) {
      this.active = index
      const menu = this.menuList.find(x => x.index === index)
      if (menu) {
        this.$router.push(menu.path)
      }
    },
    changeMenuActive() {
      const menu = this.menuList.find(x => x.path === this.currentPath)
      if (menu) {
        this.active = menu.index
      }
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 30px;
  background-color: #fff;

  .header-item {
    background-color: #fff;
    margin-right: 30px;
    border-radius: 5px;
    padding: 5px 10px;
    cursor: pointer;
  }

  .header-item:hover {
    background-color: #eeefef;
  }

  .active {
    background-color: #eeefef;
  }
}
</style>
